export default __webpack_public_path__ + "static/media/partners-logo-sogang-w@2x.026c4265.webp";